import { Vector4 } from "three"

export default function getImagePositions(img, canvasWidth, canvasHeight) {
    const canvas = document.createElement('canvas')
    canvas.width = canvasWidth
    canvas.height = canvasHeight
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight)

    const imageData = ctx.getImageData(0, 0, canvasWidth, canvasHeight)
    const rgbaPixelBuffer = imageData.data
    const positions = []

    for (let y = 0; y < canvasHeight; y++) {
        for (let x = 0; x < canvasWidth; x++) {
            const index = (y * canvasWidth + x) * 4
            if (rgbaPixelBuffer[index + 3] > 0) {

                const r = rgbaPixelBuffer[index]
                const g = rgbaPixelBuffer[index + 1]
                const b = rgbaPixelBuffer[index + 2]
                const grayscale = (0.299 * r + 0.587 * g + 0.114 * b) / 255

                positions.push(new Vector4(x - canvasWidth / 2, canvasHeight / 2 - y, 0, grayscale))
            }
        }
    }
    return positions
}